import React from "react";
import WorkHours from "../common/WorkHours";
import { FrameContext } from "../../contexts/FrameContext";
import firebaseApi from "../../apis/firebaseApi";
import dateHelpers from "../../helpers/dateHelpers";

const EditLocation = () => {
    const { companyId, locationId, isInFrame } = React.useContext(FrameContext);
    const [location, setLocation] = React.useState();
    const [workHours, setWorkHours] = React.useState();
    const [timeZone, setTimeZone] = React.useState(dateHelpers.getTimeZoneOffset());
    const [duration, setDuration] = React.useState(30);
    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");

    const [hideName, setHideName] = React.useState(false);
    const [hideEmail, setHideEmail] = React.useState(false);

    React.useEffect(() => {
        if (!companyId || !locationId) return;
        firebaseApi.getLocation(companyId, locationId, data => {
            let location = { ...data.data(), id: data.id };

            //if first time load
            if (!location.gmtOffset || !location.duration) {
                location.gmtOffset = location.gmtOffset || dateHelpers.getTimeZoneOffset();
                location.duration = location.duration || 30;
                firebaseApi.updateAgent(companyId, locationId, location);
            }

            setWorkHours(location.workHours || null);
            setDuration(location.duration || 30);
            setTimeZone(location.gmtOffset || dateHelpers.getTimeZoneOffset());
            setName(location.name || "");
            setEmail(location.email || "");

            setHideName(!!location.name);
            setHideEmail(!!location.email);

            setLocation(location);
        });
    }, [companyId, locationId]);

    const onSaveClick = () => {
        const saveData = { name: name, email: email, gmtOffset: timeZone, duration: duration, workHours: workHours };
        firebaseApi.updateLocation(companyId, locationId, saveData, () => { })
    }

    const onWorkHoursChange = wh => {
        setWorkHours(wh);
        firebaseApi.updateLocation(companyId, locationId, { workHours: wh }, () => { })
    }

    const onTimeZoneChange = e => {
        setTimeZone(e.target.value);
        firebaseApi.updateLocation(companyId, locationId, { gmtOffset: Number(e.target.value) }, () => { })
    }

    const onDurationChange = e => {
        setDuration(e.target.value);
    }

    const onDurationBlur = e => {
        firebaseApi.updateLocation(companyId, locationId, { duration: parseInt(e.target.value) }, () => { })
    }

    const onNameChange = e => {
        setName(e.target.value);
    }

    const onNameBlur = e => {
        firebaseApi.updateLocation(companyId, locationId, { name: name }, () => { })
    }

    const onEmailChange = e => {
        setEmail(e.target.value);
    }

    const onEmailBlur = e => {
        firebaseApi.updateLocation(companyId, locationId, { email: e.target.value }, () => { })
    }

    if (!location) return null;

    return (
        <div className="pf-schedule-agent-edit">
            {/* {!isInFrame() && <h3 className="text-center">{hideName ? name : "Edit Profile"}</h3>} */}
            <div className="pf-schedule-form">
                {/* {
                    !hideName &&
                    <div className="form-group">
                        <label>Name:</label>
                        <input
                            type="text"
                            value={name}
                            onChange={onNameChange}
                            onBlur={onNameBlur}
                        />
                    </div>
                } */}

                {/* <div className="form-group">
                    <label>Email:</label>
                    <input
                        type="text"
                        value={email}
                        onChange={onEmailChange}
                        onBlur={onEmailBlur}
                    />
                </div> */}
                {/* <div className="form-group">
                    <label>Time Zone:</label>
                    <input
                        type="text"
                        value={timeZone}
                        onChange={onTimeZoneChange}
                    />
                </div> */}
                <div className="form-group">
                    <label>Duration:</label>
                    <input
                        type="text"
                        value={duration}
                        onChange={onDurationChange}
                        onBlur={onDurationBlur}
                    />
                </div>
                <div className="form-group">
                    <label>Work Hours:</label>
                    <WorkHours
                        workHours={workHours}
                        onChange={onWorkHoursChange}
                    />
                </div>
                {/* <div className="pf-schedule-save-container">
                    <button type="button" onClick={onSaveClick} className="pf-schedule-btn-save">Save</button>
                </div> */}
            </div>
        </div>
    );
}

export default EditLocation;